import { Tabs } from '@arco-design/web-react';
import styled from '@emotion/styled';
import { useAtom } from 'jotai';
import { pageTabsAtom } from '../store';
import { useLocation, useNavigate } from 'react-router-dom';

const TabPane = Tabs.TabPane;
const StickyTab = styled(Tabs)`
  position: sticky;
  top: 60px;
  z-index: 100;
  background: #fff;
`;
export const PageTabs = () => {
  const [pageTabs, setPageTabs] = useAtom(pageTabsAtom);
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <StickyTab
      showAddButton={false}
      type="card-gutter"
      editable
      activeTab={location.pathname}
      onChange={(key) => navigate(key)}
      onDeleteTab={(key) => {
        const index = pageTabs.findIndex((v) => v.url === key);
        if (key === location.pathname) {
          navigate(pageTabs[index - 1].url);
        }
        setPageTabs((prev) => prev.filter((v) => v.url !== key));
      }}
    >
      {pageTabs.map((v) => (
        <TabPane key={v.url} title={v.title} closable={pageTabs.length > 1} />
      ))}
    </StickyTab>
  );
};
